import api from '@/lib/api'

const state = () => ({
  allDevices: [],
})

const getters = {
  allDevices: state => state.allDevices,
}

const actions = { 
  async loadAll ({ commit }) {
    const result = await api.get('/devices')
    if (result.ok) {
      const devices = await result.json()
      
      commit('SET_ALL_DEVICES', devices)
      return { ok: true, loaded: devices }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async createDevice ({}, device ) {
    const result = await api.post('/devices', device)
    if (result.ok) {
      return { ok: true, inserted: await result.json() }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async deleteDevice ({}, { device_id } ) {
    const result = await api.delete(`/devices/${ device_id }`)
    if (result.ok) {
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async resend_code ({}, { device_id } ) {
    const result = await api.put(`/devices/${ device_id }/resend_code`)
    if (result.ok) {
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },

  // eslint-disable-next-line no-empty-pattern
  async verify ({}, { device_id, verification_code } ) {
    const result = await api.put(`/devices/${ device_id }/verify`, { verification_code })
    if (result.ok) {
      return { ok: true, verified: await result.json() }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_ALL_DEVICES: (state, devices) => state.allDevices = devices,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}